import React, { useEffect, useState } from "react";
import {
  AppLayout,
  Grid,
  Box,
  Header,
  HelpPanel,
  Button,
  Cards,
  SpaceBetween,
} from "@cloudscape-design/components";
import { useSelector, useDispatch } from "react-redux";
import Navigation from "./components/Navigation";
import { appLayoutLabels, itemSelectionLabels } from "./components/labels";
import "../styles/home-page.scss";
import { Authenticator } from "@aws-amplify/ui-react";
import "@aws-amplify/ui-react/styles.css";
import EventLogin from "./components/EventLogin";
import LeaseLogin from "./components/LeaseLogin";
import { useParams } from "react-router";
import { regExpAll } from "./components/utils";
import GitHubLinks from "./components/GitHubLinks";
import { Auth } from "aws-amplify"; // Import Auth from AWS Amplify

const Content = () => {
  // const LOGIN_TYPE_NONE = "LOGIN_TYPE_NONE";
  // const LOGIN_TYPE_CREATE = "LOGIN_TYPE_CREATE";
  const LOGIN_TYPE_LOGIN = "LOGIN_TYPE_LOGIN";
  const LOGIN_TYPE_SAML = "LOGIN_TYPE_SAML"; // Define the LOGIN_TYPE_SAML constant
  const [isButtonVisible, setIsButtonVisible] = useState(true);

  const User = useSelector((state) => state.current_user);
  const Config = useSelector((state) => state.config);
  const [LoginType, setLoginType] = useState(LOGIN_TYPE_SAML);
  // const [LoginType, setLoginType] = useState(LOGIN_TYPE_LOGIN);
  // const [LoginType, setLoginType] = useState(LOGIN_TYPE_SAML);
  const { urlParamEventId } = useParams();

  const handleSAMLLogin = async () => {
    try {
      // Trigger SAML login by redirecting to hosted UI
      await Auth.federatedSignIn({ customProvider: "uci-students" });
    } catch (error) {
      console.error("Error during SAML login: ", error);
    }
  };

  const LoginOptions = () => (
    <Grid
      gridDefinition={[
        { offset: { l: 3, xxs: 2 }, colspan: { l: 6, xxs: 8 } }, // Centered for larger screens
        {
          colspan: { xl: 8, l: 8, s: 8, xxs: 8 },
          offset: { l: 2, s: 1, xxs: 0 },
        }, // Centered for smaller screens
      ]}
    >
      <Box width={200}>
        <Cards
          ariaLabels={itemSelectionLabels}
          cardDefinition={{
            header: (item) => item.name,
            sections: [
              {
                id: "description",
                content: (item) => item.description,
              },
              {
                id: "button",
                content: (item) => (
                  <Button
                    variant="primary"
                    onClick={() => {
                      if (item.login === LOGIN_TYPE_SAML) {
                        handleSAMLLogin();
                      } else {
                        setLoginType(item.login);
                        setIsButtonVisible(false);
                      }
                    }}
                  >
                    {item.button}
                  </Button>
                ),
              },
            ],
          }}
          cardsPerRow={[{ cards: 2 }, { maxWidth: 100, cards: 1 }]}
          items={[
            {
              name: "Students Login",
              button: "Student Login",
              description: "Use your institution credentials to login.",
              login: LOGIN_TYPE_SAML, // Custom login type for SAML
            },
            // {
            //   name: "Administrator Login",
            //   button: "Admin Login",
            //   description: "ADMIN Login",
            //   login: LOGIN_TYPE_LOGIN,
            // },
          ]}
          header={<Header>Login to your account</Header>}
        />
      </Box>
    </Grid>
  );

  return (
    <Box margin={{ bottom: "s" }}>
      <div className="custom-home__header">
        <Box padding={{ vertical: "xl", horizontal: "s" }}>
          <Grid
            gridDefinition={[
              { offset: { l: 1, xxs: 1 }, colspan: { l: 10, xxs: 12 } },
              {
                colspan: { xl: 10, l: 10, s: 10, xxs: 12 },
                offset: { l: 1, xxs: 1 },
              },
            ]}
          >
            <Box padding={{ top: "xs" }}>
              <span className="custom-home__category">
                Management of AWS accounts
              </span>
            </Box>
            <div className="custom-home__header-title">
              <Box
                variant="h2"
                fontWeight="heavy"
                padding="n"
                fontSize="display-l"
                color="inherit"
              >
                UCI Student AWS Accounts
              </Box>
              <Box
                fontWeight="light"
                padding={{ bottom: "s" }}
                fontSize="heading-m"
                color="inherit"
              >
                Temporary AWS accounts
              </Box>
              <Box variant="p">
                <span className="custom-home__header-sub-title">
                  UCI Student AWS Accounts allows you to claim temporary
                  "leases" for AWS sandbox or playground accounts, including
                  automatic AWS account cleanup after expiration.
                </span>
              </Box>
              <Box>
                {isButtonVisible && (
                  <Button
                    variant="primary"
                    onClick={() => {
                      setIsButtonVisible(false);
                      setLoginType(LOGIN_TYPE_LOGIN);
                    }}
                  >
                    For UCI Affiliates
                  </Button>
                )}
              </Box>
            </div>
          </Grid>
        </Box>
      </div>
      <Box padding={{ top: "l", horizontal: "l" }} width={300}>
        {/* {!User.isLoggedIn && LoginType === LOGIN_TYPE_NONE ? ( */}
        {!User.isLoggedIn && LoginType === LOGIN_TYPE_SAML ? (
          <LoginOptions />
        ) : (
          <Authenticator
            formFields={{
              signIn: {
                username: {
                  label: "Email",
                  placeholder: "Enter your email",
                },
                password: {
                  label: "Password",
                  placeholder: "Enter your password",
                },
              },
            }}
            loginMechanisms={["email"]}
            signUpAttributes={[]}
            initialState="signIn"
            hideSignUp
          >
            {new RegExp(regExpAll(Config.LEASE_ID_REGEX)).test(
              urlParamEventId
            ) ? (
              <LeaseLogin />
            ) : (
              <EventLogin />
            )}
          </Authenticator>
        )}
      </Box>
    </Box>
  );
};

const Home = () => {
  const User = useSelector((state) => state.current_user);
  const [navigationOpen, setNavigationOpen] = useState(User.isLoggedIn);
  const dispatch = useDispatch();
  // const [toolsOpen, setToolsOpen] = useState(false);

  useEffect(() => {
    dispatch({ type: "notification/dismiss" });
    dispatch({ type: "selection/dismiss" });
    dispatch({ type: "modal/dismiss" });
  }, [dispatch]);

  useEffect(() => {
    setNavigationOpen(!User.isLoggedIn);
  }, [User.isLoggedIn]);

  // const handleToggleTools = () => {
  //   setToolsOpen(!toolsOpen);
  // };

  return (
    <AppLayout
      disableContentPaddings={true}
      navigation={<Navigation />}
      content={<Content />}
      contentType="default"
      tools={<SideHelp />}
      // toolsOpen={{ toolsOpen }}
      // onToolsChange={({ detail }) => setToolsOpen(detail.close)}
      // header={
      //   <Header>
      //     <Button
      //       onClick={() => {
      //         handleToggleTools();
      //       }}
      //       ariaLabel="Toggle FAQ"
      //     >
      //       FAQ
      //     </Button>
      //   </Header>
      // }
      navigationOpen={navigationOpen}
      onNavigationChange={({ detail }) => setNavigationOpen(detail.open)}
      ariaLabels={appLayoutLabels}
    />
  );
};

const SideHelp = () => (
  <HelpPanel header={<h2>UCI Student AWS Accounts FAQ</h2>}>
    <SpaceBetween size="m">
      <Box>
        <strong>Lease Length</strong>
        <br />
        Your AWS account has an initial lease length of 12 weeks. If you need an
        extension, please send a request to cloud-services@uci.edu.
      </Box>
      <Box>
        <strong>Budget Limit</strong>
        <br />
        Your AWS account has a budget limit of $10. Please monitor your usage to
        ensure you stay within this limit. To stay within this limit, use
        low-cost instances and ensure that you immediately shut down any
        services that are not needed.
      </Box>
      <Box>
        <strong>Account Deletion</strong>
        <br />
        Your AWS account will be permanently deleted 14 days after the lease
        expires or the budget is exceeded. To avoid deletion, request an
        extension before the 14-day period ends, as deleted accounts cannot be
        accessed or restored.
      </Box>
    </SpaceBetween>
    <hr />
    <GitHubLinks />
  </HelpPanel>
);

export default Home;
